import { IoSchool, IoPeopleCircleSharp } from "react-icons/io5";
import { ImDatabase } from "react-icons/im";

export const valueCards = [
  {
    title: "Educate",
    icon: <IoSchool className="icon card-icon" />,
    text:
      " Pickled hashtag portland pork belly cred selvage viral retro prism lomo narwhal cray selfies vegan lyft.",
  },
  {
    title: "Teach",
    icon: <IoPeopleCircleSharp className="icon card-icon" />,
    text:
      "iPhone banh mi you probably haven't heard of them fanny pack marfa four loko freegan. XOXO salvia twee whatever post-ironic blog",
  },
  {
    title: "Centralize",
    icon: <ImDatabase className="icon card-icon" />,
    text:
      "Tilde post-ironic celiac franzen sustainable, vinyl polaroid direct trade tattooed vaporware kogi health goth cray echo park organic.",
  },
];

export const teamCards = [
  {
    title: "Dennis Rodman",
    img:
      "https://sportnews.snai.it/wp-content/uploads/2020/05/GettyImages-625824450.jpg",
    subtitle: "CEO & Founder",
  },
  {
    title: "Tatyana Doglieva",
    img:
      "https://i1.wp.com/alabanza.ru/wp-content/uploads/2018/04/Instagram-i-Vikipediya-Tatyany-Dogilevoj-foto.jpg",
    subtitle: "CTO",
  },
  {
    title: "Charlie Sheen",
    img:
      "https://www.ecodelcinema.com/wp-content/uploads/2013/10/Charlie-Sheen.png",
    subtitle: "Stakeholder",
  },
  {
    title: "Shia J. Lebeouf",
    img:
      "https://www.corriere.it/methode_image/2021/01/15/Moda/Foto%20Moda/8%20shia%20labeouf.jpg",
    subtitle: "Creative Director",
  },
];
